import React,{ useEffect, useState } from 'react';
import SpicyLevel from '../options/SpicyLevel'
import AddBall from '../options/AddBall';
import AddEgg from '../options/AddEgg';
import Remark from '../options/Remark';
import Amount from '../options/Amount';
const Soup_Options = ({ handleCheckChange, formValues, handleBallChange, handleEggChange, handleInputChange, handleSubtract, handleAdd }) => {
  
  return (
    <>
    <SpicyLevel handleCheckChange={handleCheckChange}/>
    <AddBall formValues = { formValues } handleBallChange = { handleBallChange }/>
    <AddEgg formValues = { formValues } handleEggChange = { handleEggChange }/>
    <Remark formValues = { formValues }  handleInputChange = { handleInputChange }/>
    <Amount handleAdd={ handleAdd } handleSubtract={ handleSubtract } formValues = { formValues }/>
    </>

  );
};

export default Soup_Options;
